<template>
  <a-card :bordered="false" :body-style="{ padding: '16px' }">
    <div class="container">
      <div
        v-for="(item, index) in data"
        :key="index"
        class="item"
        :class="{ 'item-flex-start': flexStart }"
        :style="{ backgroundColor: item.bgColor }"
      >
        <div class="item-img">
          <img :src="item.icon" alt="" />
        </div>
        <div class="item-content">
          <div class="item-header">
            <h5 :title="item.title" class="item-title">{{ item.title }}</h5>
            <span v-if="item.operate" class="item-operate">
              <slot :name="item.operate" />
            </span>
          </div>
          <h3 :title="item.count">{{ item.count }}</h3>
          <div v-if="item.desc" class="item-desc">
            <slot :name="item.desc" />
          </div>
        </div>
      </div>
    </div>
  </a-card>
</template>

<script>
export default {
  name: 'StatisticsWithIcon',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    flexStart: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="less" scoped>
@import url('./index.less');
</style>
